<div class="external-auth-bootstrap">
  <div class="external-auth-bootstrap__card">
    <div class="external-auth-bootstrap__spinner"></div>
    <p>{{ message }}</p>
  </div>
</div>
